import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://burgerbuilder-729bb.firebaseio.com/'
})

export default instance


// WEBPACK FOOTER //
// ./src/axios-orders.js